import { testosteroneSupportEd } from './initial';

const TestosteroneSupportEdFlows = {
  testosteroneSupportEd
};

export default TestosteroneSupportEdFlows;